import {
  INTERVIEW_HISTORY_REQUEST, INTERVIEW_HISTORY_FAIL, INTERVIEW_HISTORY_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const InterviewHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case INTERVIEW_HISTORY_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case INTERVIEW_HISTORY_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case INTERVIEW_HISTORY_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default InterviewHistoryReducer;
